import { useEntity } from '@backstage/plugin-catalog-react';
import {
  InfoCard,
  EmptyState,
} from '@backstage/core-components';
import { Button, List, ListItem, ListItemText } from '@material-ui/core';

const CLOUD_LOGGING_ANNOTATION = 'google.com/cloud-logging-filter';
const GCP_PROJECT_ANNOTATION = 'google.com/gcp-project';

export const EntityGoogleCloudLoggingCard = () => {
  const { entity } = useEntity();
  const annotations = entity.metadata.annotations ?? {};
  const loggingFilter = annotations[CLOUD_LOGGING_ANNOTATION];
  const gcpProject = annotations[GCP_PROJECT_ANNOTATION];

  if (!loggingFilter && !gcpProject) {
    return (
      <InfoCard title="Google Cloud Logging">
        <EmptyState
          missing="info"
          title="No Google Cloud Logging configured"
          description='Add the "google.com/cloud-logging-filter" and "google.com/gcp-project" annotations to this entity to enable Cloud Logging links.'
        />
      </InfoCard>
    );
  }

  const serviceName = entity.metadata.name;
  const filter = loggingFilter || `resource.labels.service_name="${serviceName}"`;
  const project = gcpProject || 'YOUR_GCP_PROJECT';

  const consoleUrl = `https://console.cloud.google.com/logs/query;query=${encodeURIComponent(filter)};project=${encodeURIComponent(project)}`;

  return (
    <InfoCard title="Google Cloud Logging">
      <List>
        <ListItem>
          <ListItemText
            primary="Log Explorer"
            secondary={`Filter: ${filter}`}
          />
          <Button
            variant="outlined"
            color="primary"
            size="small"
            href={consoleUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            Open in Cloud Console
          </Button>
        </ListItem>
      </List>
    </InfoCard>
  );
};
